module.exports = __webpack_public_path__ + "img/avatar-81.81aa3cb0.png";